import store from "@/store/index";
import Shortcut from '../../../foxitwebsdk/src/shared/Shortcut.js';

export default class ShortcutService {
    constructor () {
        Shortcut.register(document.body, 'ctrl+o', (e) => {
            // Open File
            e.preventDefault();
            store.appStore.showOpenFileDlg(false, 'LOCAL_COMPUTER');
        });
        Shortcut.register(document.body, 'ctrl+d', (e) => {
            // Document Properties
            e.preventDefault();
            if (this.hasOtherDialog()) return ;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            const pdfUI = store.viewer.pdfui;
            pdfUI.openDialog('file-property-popup').then(popup => {
                popup.show();
            });
        });
        Shortcut.register(document.body, ['17+107', 'ctrl+='], (e) => {
            // Zoom In ctrl++
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            let scale = pdfDocRender.scale;
            scale = isNaN(scale) ? 1 : scale;
            scale += 0.25
            pdfUI.zoomTo(Math.min(scale, 10));
        });
        Shortcut.register(document.body, 'ctrl+-', (e) => {
            // Zoom In
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            let scale = pdfDocRender.scale;
            scale = isNaN(scale) ? 1 : scale;
            scale -= 0.25
            pdfUI.zoomTo(Math.max(scale, 0.5));
        });
        Shortcut.register(document.body, 'ctrl+m', (e) => {
            // Zoom To
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            pdfUI.getComponentByName('float-bar-view-size').then(component => {
                const el = component.numberInput.input;
                el.focus();
            });
        });
        Shortcut.register(document.body, 'ctrl+0', (e) => {
            // Fit to Page
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            pdfUI.zoomTo('fitHeight');
        });
        Shortcut.register(document.body, 'ctrl+1', (e) => {
            // Actual Size
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            pdfUI.zoomTo(1);
        });
        Shortcut.register(document.body, 'ctrl+2', (e) => {
            // Fit Width
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            pdfUI.zoomTo('fitWidth');
        });
        Shortcut.register(document.body, 'ctrl+3', (e) => {
            // Fit Visible
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            pdfUI.zoomTo('fitVisible');
        });
        Shortcut.register(document.body, '17+16+107', (e) => {
            // Rotate Clockwise
            e.preventDefault();
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            const currentPageNumber = pdfDocRender.currentPageNumber;
            const pdfPage = pdfDocRender.getPDFPageRender(currentPageNumber).page;
            let rotation = pdfPage.getRotation();
            rotation += 1;
            pdfPage.setRotation(rotation > 4 ? 1 : rotation);
        });
        Shortcut.register(document.body, 'ctrl+shift+-', (e) => {
            // Rotate Counterclockwise
            e.preventDefault();
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            const currentPageNumber = pdfDocRender.currentPageNumber;
            const pdfPage = pdfDocRender.getPDFPageRender(currentPageNumber).page;
            let rotation = pdfPage.getRotation();
            rotation -= 1;
            pdfPage.setRotation(rotation < 0 ? 3 : rotation);
        });
        Shortcut.register(document.body, 'ctrl+shift+h', (e) => {
            // AutoScroll Ctrl
            e.preventDefault();
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = undefined;
                return ;
            }
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            pdfUI.pdfViewer.viewModeManager.switchTo('continuous-view-mode');
            const dom = document.querySelector('.fv__ui-pdfviewer');
            this.timer = setInterval(() => {
                dom.scrollTop += 1;
            }, 100);
        });
        Shortcut.register(document.body, 'esc', (e) => {
            // Stop AutoScroll
            e.preventDefault();
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = undefined;
            }
        });
        Shortcut.register(document.body, 'ctrl+h', (e) => {
            // View file in read mode
            e.preventDefault();
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            this.getToolComponent('view-tab', 'read-mode-button').then(component => {
                if (!component) return ;
                const controller = component.controller;
                const mode = controller.mode;
                if (mode === 'reading') {
                    controller.exitReadMode();
                } else {
                    controller.enterReadMode();
                }
            });
        });
        Shortcut.register(document.body, 'ctrl+g', (e) => {
            // Go to Page
            e.preventDefault();
            this.getToolComponent('', 'gotopage-input').then(component => {
                component && component.element.focus();
            });
        });
        Shortcut.register(document.body, 'ctrl+home', (e) => {
            // First Page
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            pdfUI.goToPage(0);
        });
        Shortcut.register(document.body, 'ctrl+end', (e) => {
            // Last Page
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            const count = pdfDocRender.doc.getPageCount();
            pdfUI.goToPage(count - 1);
        });
        Shortcut.register(document.body, 'alt+5', (e) => {
            // Marquee Zoom
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            pdfUI.getStateHandlerManager().then(stateHandlerManager => {
                stateHandlerManager && stateHandlerManager.switchTo('marquee');
            });
        });
        Shortcut.register(document.body, 'ctrl+r', (e) => {
            // Rules
            e.preventDefault();
            const pdfUI = store.viewer.pdfui;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            pdfUI.eventEmitter.emit('ToggleRulers');
        });
        Shortcut.register(document.body, 'ctrl+k', (e) => {
            // Preferences 
            e.preventDefault();
            if (this.hasOtherDialog()) return ;
            store.viewer.pdfui.customs.showPreferences();
        });
        Shortcut.register(document.body, 'ctrl+u', (e) => {
            // Duplicate pages 
            e.preventDefault();
            if (this.hasOtherDialog()) return ;
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            this.getToolComponent('organize-tab', 'duplicate-pages-button').then(component => {
                component && component.controller.handle();
            });
        });
        Shortcut.register(document.body, 'alt+3', (e) => {
            // Hand Tool
            e.preventDefault();
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            this.getToolComponent('', 'hand-tool').then(component => {
                component && component.controller.handle();
            });
        });
        Shortcut.register(document.body, 'alt+6', (e) => {
            // Select Text and Image
            e.preventDefault();
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            this.getToolComponent('', 'select-text-image').then(component => {
                component && component.controller.handle();
            });
        });
        Shortcut.register(document.body, 'alt+7', (e) => {
            // Snapshot
            e.preventDefault();
            const pdfDocRender = store.viewer.pdfViewer.getPDFDocRender();
            if (!pdfDocRender) return ;
            this.getToolComponent('', 'snapshot-button').then(component => {
                component && component.controller.handle();
            });
        });
        

    }

    getToolComponent (tabName, btnName) {
        const pdfUI = store.viewer.pdfui;
        const clickReadModeBtn = () => {
            return pdfUI.getComponentByName(btnName).then(component => {
                if (component) return component;
                return pdfUI.getComponentByName(tabName).then(component => {
                    if (!component) return ;
                    component.active();
                    return new Promise((res, rej) => {
                        setTimeout(() => {
                            clickReadModeBtn().then(res, rej);
                        }, 1000);
                    });
                });
            });
        }
        return clickReadModeBtn();
    }
    hasOtherDialog () {
        return !!document.querySelector('.fv__ui-layer-modal')
            || !!document.querySelector('.ant-modal-wrap');
    }
}